// SiteFooter — legal + meta links on public pages. Hidden on the
// canvas routes (/flow-weaver, /preview) where vertical space is
// precious and the ProfileMenu already links to legal pages.

import { Link, useLocation } from 'react-router-dom';

const HIDDEN_PREFIXES = ['/flow-weaver', '/preview', '/admin', '/atlas', '/processengine', '/final', '/search'];

export function SiteFooter() {
  const { pathname } = useLocation();
  if (HIDDEN_PREFIXES.some((p) => pathname.startsWith(p))) return null;

  return (
    <footer
      className="border-t bg-muted/30 py-6 px-4 text-xs text-muted-foreground"
      data-testid="site-footer"
    >
      <div className="max-w-4xl mx-auto flex flex-wrap items-center justify-between gap-3">
        <span>© {new Date().getFullYear()} EngiCoro AB</span>
        <nav className="flex flex-wrap items-center gap-x-4 gap-y-1" aria-label="Sidfot">
          <Link to="/pricing" className="hover:underline">Priser</Link>
          <Link to="/changelog" className="hover:underline">Changelog</Link>
          <Link to="/privacy" className="hover:underline">Integritetspolicy</Link>
          <Link to="/terms" className="hover:underline">Användarvillkor</Link>
          <Link to="/legal/security" className="hover:underline">Säkerhet</Link>
        </nav>
      </div>
    </footer>
  );
}
